var React = require('react');

function CheckmarkSolidCircle (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2660_5285)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M26 51C40.0833 51 51.5 39.5833 51.5 25.5C51.5 11.4167 40.0833 0 26 0C11.9167 0 0.5 11.4167 0.5 25.5C0.5 39.5833 11.9167 51 26 51ZM35.2638 9.5625L23.1624 30.0885L14.3086 20.8607L10.0625 25.0141L24.2912 39.8438L40.3438 12.6158L35.2638 9.5625Z","fill":"#005DFF"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2660_5285"},React.createElement("rect",{"width":"51","height":"51","fill":"white","transform":"translate(0.5)"})))]);
}

CheckmarkSolidCircle.defaultProps = {"width":"52","height":"51","viewBox":"0 0 52 51","fill":"none"};

module.exports = CheckmarkSolidCircle;

CheckmarkSolidCircle.default = CheckmarkSolidCircle;
